"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const GlobalStyle = styled_components_1.createGlobalStyle `
  body {
    margin: 0;
    padding: 0;
    font-family: Segoe UI;

  }
`;
function default_1({ children }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(GlobalStyle, null),
        children));
}
exports.default = default_1;
//# sourceMappingURL=index.js.map